import { colors } from '@cobliteam/ui/theme';
import { css } from 'emotion';

import { Severity } from '@cobliteam/common-types';

import { fonts, icons } from '@cobliteam/base-components/src/styles';

export const popup = css`
  position: relative;
  width: 400px;
  display: flex;
  flex-direction: column;

  :before {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100%);
    border-top: 11px solid ${colors.gray[4]};
    border-right: 11px solid transparent;
    border-left: 11px solid transparent;
  }

  :after {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100%);
    border-top: 10px solid ${colors.white.DEFAULT};
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
  }
`;

export const header = css`
  display: flex;
  align-items: center;
  padding: 15px 20px;
  background: ${colors.gray[2]};

  & > *:not(:first-child) {
    margin-left: 15px;
  }

  & > *:last-child {
    margin-left: auto;
  }
`;

export const badge = (severity?: Severity) => css`
  color: ${colors.gray.dark};
  ${severity === Severity.MEDIUM && `color: ${colors.warning[9]};`}
  ${severity === Severity.SEVERE && `color: ${colors.danger[9]};`}
  ${severity === Severity.VERY_SEVERE && `color: ${colors.danger[10]};`}
`;

export const speedSign = (isRoadSpeedLimit: boolean, speed: number) => css`
  &:before {
    content: "${speed}";
    border-radius: 50%;
    box-sizing: border-box;
    background: ${colors.white};
    border: 3.2px solid
      ${isRoadSpeedLimit ? colors.danger[9] : colors.gray[10]};
    font-weight: ${fonts.weight.medium};
    width: ${icons.size.larger};
    height: ${icons.size.larger};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${fonts.size.smallest};
    font-weight: ${fonts.weight.bold};
  }
`;

export const body = css`
  padding: 15px 20px 20px;
`;

export const reachedSpeedRow = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  height: 25px;
`;

export const speedIcon = css`
  margin: 0 5px 2px 0;
`;

export const severityTag = (severity?: Severity) => css`
  margin-left: 30px;
  color: ${colors.white.DEFAULT};

  ${severity === Severity.SEVERE && `background: ${colors.danger[9]};`}
  ${severity === Severity.VERY_SEVERE && `background: ${colors.danger[10]};`}
`;

export const infoRow = css`
  margin-top: 10px;
`;

export const addressPlaceholder = css`
  vertical-align: middle;
`;

export const footer = css`
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 1px solid ${colors.gray[4]};
`;

export const footerNote = css`
  width: 230px;
`;
